import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";

const AcceptInvite = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState("");

  const acceptInvite = async () => {
    if (!token) {
      setError("Invalid or missing invitation token.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await axios.post(
        `${config.API_BASE_URL}/invite/accept`,
        { token }
      );

      const { email, role, inviteSessionToken } = res.data;

      if (!email || !role || !inviteSessionToken) {
        setError("This invitation is invalid or expired.");
        return;
      }

      const normalizedRole = role.toLowerCase();

      // 🔐 Store invite context
      sessionStorage.setItem("inviteEmail", email);
      sessionStorage.setItem("inviteRole", normalizedRole);
      sessionStorage.setItem("inviteSessionToken", inviteSessionToken);

      setAccepted(true);

      // ⏳ Short delay before redirect
      setTimeout(() => {
        if (
          normalizedRole === "patient" ||
          normalizedRole === "resident user"
        ) {
          navigate("/patientregister");
        } else if (
          normalizedRole === "worker" ||
          normalizedRole === "remote worker"
        ) {
          navigate("/remoteregister");
        } else {
          setError("Unknown role in invitation.");
        }
      }, 1000);

    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to accept invitation."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={container}>
      <div style={card}>
        {error && <p style={errorText}>{error}</p>}

        {!accepted && !error && (
          <>
            <h2 style={title}>You’ve been invited</h2>
            <button
              onClick={acceptInvite}
              disabled={loading}
              style={primaryBtn}
            >
              {loading ? "Accepting..." : "Accept Invitation"}
            </button>
          </>
        )}

        {accepted && (
          <>
            <h2 style={successTitle}>Invitation Accepted 🎉</h2>
            <p>Redirecting to registration…</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptInvite;


/* =====================
   STYLES
===================== */

const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #eef2f7, #f9fbfd)"
};

const card = {
  background: "#fff",
  padding: "36px",
  width: "420px",
  textAlign: "center",
  borderRadius: "14px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.12)"
};

const title = { color: "#0E5580", marginBottom: 6 };

const primaryBtn = {
  width: "100%",
  padding: 12,
  background: "#0E5580",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer"
};

const errorText = { color: "#c0392b", marginBottom: 16 };
const successTitle = { color: "#198754", marginBottom: 10 };
